// extracted by mini-css-extract-plugin
export default {"list":"list_list__4GWH6 shadow","item":"list_item__kL8r2"};